<template>
    <div class="driver-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <p-header title="我的收藏騎士"/>
        <div class="list">
            <driver-item v-for="driver in drivers" :driver="driver" :key="driver.id"/>
        </div>
        <div class="footer" v-show="cart.driver">
            <div class="button" @click.stop="confirm">
                指定騎士
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "../Header";
    import DriverItem from "./DriverItem";
    import { getDrivers } from '../../../apis';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "DriverList",
        components: {
            'p-header': Header,
            'driver-item': DriverItem,
        },
        data() {
            return {
                loading: false,
                drivers: [],
                meta: {
                    current_page: 0,
                    total: 0,
                },
            }
        },
        computed: {
            canNotLoadMore() {
                return !(this.meta.total && this.meta.current_page < this.meta.last_page && !this.loading);
            },
            ...mapGetters(['cart']),
        },
        methods: {
            loadMore() {
               let payload = {
                   page: this.meta.current_page + 1,
                   type: this.$route.params.type,
               }

               this.loading = true;
               getDrivers(payload).then(res => {
                   this.meta = res.data.meta;
                   this.drivers = this.drivers.concat(res.data.data).filter((driver, index, drivers) => {
                       return drivers.findIndex(d => d.id === driver.id) === index;
                   })
                   this.loading = false;
               });
            },
            confirm() {
                this.confirmDriver();
               this.$router.go(-2);
            },
            ...mapActions(['confirmDriver']),
        },
        created() {
            let payload = {
                page: this.meta.current_page + 1,
                type: this.$route.params.type,
            }

            getDrivers(payload).then(res => {
                this.drivers = res.data.data;
                this.meta = res.data.meta;
            })
        }
    }
</script>

<style lang="scss" scoped>
    .driver-list {
        .list {
            padding: 15px;
            margin-bottom: 70px;
        }

        .footer {
            padding: 15px;
            position: fixed;
            bottom: 0;
            width: calc(100% - 30px);
            max-width: 470px;
            background-color: #ffffff;

            .button {
                cursor: pointer;
                user-select: none;
                background-color: #339933;
                padding: 13px;
                border-radius: 35px;
                color: #FFF;
                font-size: 14px;
            }
        }
    }
</style>